import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { palette } from '@openx/components-core/lib/theme/paletteV2';
import { abbreviateNumericValue } from '@openx/utils/lib/abbreviateNumericValue';
import { useTranslation } from 'react-i18next';

type MetricsOverviewItemProps = {
  value: number | null;
  title: string;
  prefix?: string;
  suffix?: string;
  allowZero?: boolean;
};

export const MetricsOverviewItem = ({
  value,
  title,
  prefix = '',
  suffix = '',
  allowZero = false,
}: MetricsOverviewItemProps) => {
  const { t } = useTranslation();
  const shouldRenderPrefixSuffix = value !== null && (value !== 0 || allowZero);
  const isPercentage = suffix === '%';

  return (
    <Box data-test={`funnel-metrics-${title.toLocaleLowerCase()}`}>
      <Typography variant="body2Bold" color={palette.text.secondary}>
        {title}
      </Typography>
      {value === null ? (
        <Typography variant="h2" sx={{ '::before': { display: 'none' } }} color="textDisabled">
          {t('N/A')}
        </Typography>
      ) : (
        <Typography variant="h2" sx={{ '::before': { display: 'none' }, whiteSpace: 'nowrap' }}>
          {shouldRenderPrefixSuffix && prefix}
          {abbreviateNumericValue(value, { allowZero, multiplier: isPercentage ? 100 : 1 })}
          {shouldRenderPrefixSuffix && suffix}
        </Typography>
      )}
    </Box>
  );
};
